
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { CARD_TYPES } from "@/constants/cards";
import { ICardDetails, ICard } from "@/store/applications/types";
import splitStringOnCapital from "@/plugins/filters/stringFilter";
import { Products } from "@/api/signup/types/CardModel";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);
const MONTHLY_LIMIT = {
  LOW: 1000,
  HIGH: 10000
};

/**
 * Returns the IFCS coded product restriction for a given product restriction.
 * This is required so that the bot can enter the data into IFCS correctly.
 */
function GetIfcsProductRestriction(product: Products) {
  switch (product) {
    case Products.All:
      return "All";
    case Products.AllExcludingAdBlue:
      return "All products excl AdBlue";
    case Products.AllExcludingTobacco:
      return "All Products excl Tobacco";
    case Products.AllExcludingTobaccoAndAdBlue:
      return "All Products excl Tobacco & AdBlue";
    case Products.DieselOilWashAndService:
      return "Diesel Oil Wash & Srvc";
    case Products.FuelsAndAdBlue:
      return "Fuels & AdBlue";
    case Products.FuelsOilWashService:
      return "Fuels Oil Wash & Srvc";
    case Products.FuelsOnly:
      return "Fuels Only";
    case Products.PetrolOilAndWash:
      return "Petrol Oil & Wash";
  }
}

export default Vue.extend({
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    activeCard() {
      return this.cards && this.cards[this.activeIndex];
    },
    shouldDisplayOdomenter() {
      return this.activeCard && this.activeCard.cardType === CARD_TYPES.VEHICLE;
    },
    isAllProducts() {
      return (this.products || "").toLowerCase() === "all";
    },
    hasDailyLimit() {
      return Boolean(this.dailyLimit);
    },
    shouldDisplayTelnetSection() {
      return !(
        this.isAllProducts &&
        !this.hasDailyLimit &&
        (this.monthlyLimit || 0) >= MONTHLY_LIMIT.HIGH
      );
    },
    cards() {
      const cardDetails: ICardDetails =
        store.getters[APPLICATION.NS(APPLICATION.GETTERS.GET_CARD_DETAILS)];

      return cardDetails && cardDetails.cards;
    },
    cardDetails: () => {
      return (
        store.state.application.applicationData &&
        store.state.application.applicationData.cardDetails
      );
    },
    cardProfile() {
      const cardType = this.activeCard && this.activeCard.cardType;

      if (
        this.isAllProducts &&
        !this.hasDailyLimit &&
        (this.monthlyLimit || 0) >= MONTHLY_LIMIT.HIGH
      ) {
        if (cardType === CARD_TYPES.VEHICLE) {
          return "Z Business Vehicle Card Control Profile - No Limit";
        } else {
          return "Z Business Driver Card Control Profile - No Limit";
        }
      }
      return "";
    },
    products() {
      return GetIfcsProductRestriction(this.activeCard?.products);
    },
    monthlyLimit() {
      return (
        this.activeCard &&
        this.activeCard.limits &&
        this.activeCard.limits.monthly
      );
    },
    dailyLimit() {
      return (
        this.activeCard &&
        this.activeCard.limits &&
        this.activeCard.limits.daily
      );
    }
  },
  methods: {
    cardSelectChange(event: any) {
      this.activeIndex = event.target.value;
    }
  }
});
